export const Bulk_Min_Amount = {
  'INR': { minamt: 50, incramt: 50 },
  'GBP': { minamt: 10, incramt: 10 },
  'EUR': { minamt: 10, incramt: 10 },
  'AED': { minamt: 10, incramt: 10 },
  'SAR': { minamt: 10, incramt: 10 },
  'USD': { minamt: 10, incramt: 10 },
  'SGD': { minamt: 10, incramt: 10 },
  'CAD': { minamt: 10, incramt: 10 },
  'HKD': { minamt: 10, incramt: 10 },
  'QAR': { minamt: 10, incramt: 10 },
  'AUD': { minamt: 10, incramt: 10 },
  'MYR': { minamt: 10, incramt: 10 }
};
